<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card :no-body="true">
          <b-card-body class="p-0 clearfix">
            <i class="fa fa-arrow-left bg-primary p-3 font-2xl mr-3 float-left"  @click.stop.prevent="$router.go(-1)"> </i>

          
            <div class="h5 text-primary mb-0 pt-1">Resumo Diário</div>
            <div class="text-muted text-uppercase font-weight-bold font-xs">Painel de Produção</div>
          
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>  
    <b-row>
      <b-col sm="12">
        <ul class="icons-list">
          <li v-for="(value, key) in listaResumo.itens" >
            <i class="icon-layers bg-gray-100"></i>
            <div class="desc">
              <div class="title">{{value.DESCRICAO}}</div>
              <small>Todos os Estoques</small>
            </div>
            <div class="value">
              <div class="small text-muted">KG: {{ value.PESO_TOTAL.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) }}</div>
              <strong>{{value.PECAS_TOTAL}}</strong>
            </div>
            
            
          </li>  
        </ul>  
      </b-col>
      <hr>     
    </b-row>
    <b-card>
      <b-row>
        <b-col sm="12">
          <h4 id="traffic" class="card-title mb-0">Acompanhamento {{producao.parametros.lbdata}}
            <b-overlay
                    :show="producao.dia.busy"
                    spinner-variant="warning"
                    class="d-md-block float-right">
                <b-button  
                        type="button" @click.stop.prevent="onSelecionarNovaData()" 
                        variant="primary" ><i class="icon-refresh"></i>
                </b-button>
                <b-button  
                        type="button" @click.stop.prevent="onImprimirProducao()" 
                        variant="warning" ><i class="icon-printer"></i>
                </b-button>
                <!--
                <b-dropdown class="float-right" variant="info" right>
                  <template slot="button-content">
                    <i class="icon-calendar"></i>
                  </template>
                  <b-dropdown-item @click.stop.prevent="onAbrirModalData()">Escolher outra Data</b-dropdown-item>
                </b-dropdown>
                 -->
                
                <b-button  
                        type="button" @click.stop.prevent="onAbrirModalData()" 
                        variant="info" ><i class="icon-calendar"></i>
                </b-button>
                
            </b-overlay>
          </h4>
          <div class="small text-muted">Dados do dia selecionado</div>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="3">
          <b-card header="PRODUÇÃO TOTAL">
            <div class="chart-wrapper">
              <doughnut-producao :data="doughnutProducaoTotal.data" :labels="doughnutProducaoTotal.labels" :backgrounds="doughnutProducaoTotal.backgrounds"></doughnut-producao>
            </div>
          </b-card>
        </b-col>
        <b-col sm="3">
          <b-card header="PRODUÇÃO PRÓPRIA">
            <div class="chart-wrapper">
              <doughnut-producao :data="doughnutProducaoPropria.data" :labels="doughnutProducaoPropria.labels" :backgrounds="doughnutProducaoPropria.backgrounds"></doughnut-producao>
            </div>
          </b-card>
        </b-col>
        <b-col sm="3">
          <b-card header="PRODUÇÃO SERVICO">
            <div class="chart-wrapper">
              <doughnut-producao :data="doughnutProducaoServico.data" :labels="doughnutProducaoServico.labels" :backgrounds="doughnutProducaoServico.backgrounds"></doughnut-producao>
            </div>
          </b-card>
        </b-col>
        <b-col sm="3">
          <b-card header="QUALIDADE">
            <div class="chart-wrapper">
              <doughnut-producao :data="doughnutProducaoQualidade.data" :labels="doughnutProducaoQualidade.labels" :backgrounds="doughnutProducaoQualidade.backgrounds"></doughnut-producao>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <!--
         <main-chart-example class="chart-wrapper" style="height:300px;margin-top:40px;" height="300"></main-chart-example>
         -->
      <!--
      <div slot="footer">
        <ul>
          <li>
            <div class="text-muted">Visits</div>
            <strong>29.703 Users (40%)</strong>
            <b-progress height={} class="progress-xs mt-2" :precision="1" variant="success" :value="40"></b-progress>
          </li>
          <li class="d-none d-md-table-cell">
            <div class="text-muted">Unique</div>
            <strong>24.093 Users (20%)</strong>
            <b-progress height={} class="progress-xs mt-2" :precision="1" variant="info" :value="20"></b-progress>
          </li>
          <li>
            <div class="text-muted">Pageviews</div>
            <strong>78.706 Views (60%)</strong>
            <b-progress height={} class="progress-xs mt-2" :precision="1" variant="warning" :value="60"></b-progress>
          </li>
          <li class="d-none d-md-table-cell">
            <div class="text-muted">New Users</div>
            <strong>22.123 Users (80%)</strong>
            <b-progress height={} class="progress-xs mt-2" :precision="1" variant="danger" :value="80"></b-progress>
          </li>
          <li class="d-none d-md-table-cell">
            <div class="text-muted">Bounce Rate</div>
            <strong>40.15%</strong>
            <b-progress height={} class="progress-xs mt-2" :precision="1" :value="40"></b-progress>
          </li>
        </ul>
      </div>
      -->
    </b-card>
    <b-row>
      <b-col md="12">
        <b-card header="Ordens de Abate">
          
          <b-table  class="mb-0 table-outline" 
                    responsive="sm" 
                    hover 
                    stacked="md"
                    small
                    :items="tabelaOrdens.items" 
                    :fields="tabelaOrdens.fields" 
                    head-variant="light"
                    @row-clicked="myRowClickHandler">
            <!--
            <template #cell(avatar)="item" >
              <img :src="item.value.url" class="img-avatar" alt="">
              <span class="avatar-status" v-bind:class="{ 'bg-info': item.value.status == 'info', 'bg-success': item.value.status == 'success',  'bg-warning': item.value.status == 'warning', 'bg-danger': item.value.status == 'danger', 'bg-secondary': item.value.status == '' }"></span>
            </div>
            -->
            
            <template #cell(STATUS)="item" >
              <div>
                <b-badge :variant="variantStatus(item.item.OP_STATUS)">{{item.item.STATUS}}</b-badge>
              </div>
            </template>
            <template #cell(TIPO_SERVICO_TRADUZIDO)="item" >
              <div>
                <b-badge :variant="variantServico(item.item.OP_TIPO_SERVICO)">{{item.item.TIPO_SERVICO_TRADUZIDO}}</b-badge>
              </div>
            </template>
            <template #cell(actions)="item">
                <b-button 
                      type="button" @click.stop.prevent="imprimirOrdem(item)" size="sm" variant="warning"   >
                  <i class="fa fa-print"></i>
                </b-button>
            </template>
            <!--
            <template #cell(saldoAnterior)="item" >
              <div class="small text-muted">No início do Dia de Hoje</div>
              <template v-if="item.value.value == '0'">
                <strong>Sem Movimento</strong>
              </template>
              <template v-else>
                <strong>{{item.value.value}}</strong>
              </template>
            </template>
            <template #cell(entradas)="item" >
              <div class="clearfix">
                <div class="float-left">
                  <strong>{{item.value.value}}</strong>
                  <strong>({{item.value.percentual}}%)</strong>
                </div>
              </div>
              <b-progress height={} class="progress-xs" v-model="item.value.percentual" :variant="variant(100)"></b-progress>
            </template>
            <template #cell(saidas)="item" >
              <div class="clearfix">
                <div class="float-left">
                  <strong>{{item.value.value}}</strong>
                  <strong>({{item.value.percentual}}%)</strong>
                </div>
              </div>
              <b-progress height={} class="progress-xs" v-model="item.value.percentual" :variant="variant(50)"></b-progress>
            </template>
            <template #cell(saldoAtual)="item" >
              <div class="small text-muted">Até o momento</div>
              <template v-if="item.value.value == '0'">
                <strong>Sem Movimento</strong>
              </template>
              <template v-else>
                <strong>{{item.value.value}}</strong>
              </template>
            </template>
            -->
          </b-table>
          <!--
          <b-table class="mb-0 table-outline" responsive="sm" hover :items="tableItems" :fields="tableFields" head-variant="light">
            <div slot="avatar" class="avatar" slot-scope="item">
              <img :src="item.value.url" class="img-avatar" alt="">
              <span class="avatar-status" v-bind:class="{ 'bg-success': item.value.status == 'success',  'bg-warning': item.value.status == 'warning', 'bg-danger': item.value.status == 'danger', 'bg-secondary': item.value.status == '' }"></span>
            </div>
            <div slot="user" slot-scope="item">
              <div>{{item.value.name}}</div>
              <div class="small text-muted">
                <span>
                  <template v-if="item.value.new">New</template>
                  <template v-else>Recurring</template>
                </span> | Registered: {{item.value.registered}}
              </div>
            </div>
            <i slot="country" class="h4 mb-0" :class="flag(item.value.flag)" slot-scope="item" :title="item.value.flag" :id="item.value.flag"></i>
            <i class="flag-icon flag-icon-pw h1" title="pw" id="pw"></i>
            <div slot="usage" slot-scope="item">
              <div class="clearfix">
                <div class="float-left">
                  <strong>{{item.value.value}}%</strong>
                </div>
                <div class="float-right">
                  <small class="text-muted">{{item.value.period}}</small>
                </div>
              </div>
              <b-progress height={} class="progress-xs" v-model="item.value.value" :variant="variant(item.value.value)"></b-progress>
            </div>
            <i slot="payment" slot-scope="item" :class="item.value.icon" style="font-size:24px"></i>
            <div slot="activity" slot-scope="item">
              <div class="small text-muted">Last login</div>
              <strong>{{item.value}}</strong>
            </div>
          </b-table>

          -->
        </b-card>
      </b-col>
    </b-row>
    <div>
        <div>     
          <b-modal ref="modal-data" 
              id="modal-data" 
              hide-header
              body-class="p-0"
              size="lg"
              headerClass= "p-2 border-bottom-0" 
              title="Mudar a data da Produção" >
            <b-overlay :show="producao.parametros.overlay" 
                        no-wrap 
                        z-index="1100" 
                        spinner-variant="primary"
                        spinner-type="border">
              <template #overlay>
                <div class="text-center">
                  <b-icon icon="stopwatch" font-scale="3" animation="cylon"></b-icon>
                  <p>Por favor. Aguarde!!!...</p>
                </div>
              </template>
            </b-overlay>
            <b-card bg-variant="light">
                <div slot="header">
                    <i class='fa fa-align-justify'></i><strong>  Data da Produção</strong>
                </div>
                <b-row>
                  <b-col sm="12" >
                    <b-calendar 
                        block 
                        v-model="producao.parametros.data"  
                        :date-disabled-fn="dateDisabled"
                        @selected="onSelecionarNovaData()"
                        labelHelp="Datas que tiveram Abate"
                        labelPrevDecade = "Decada Anterior"
                        labelPrevYear = 'Ano Anterior'
                        labelPrevMonth="Mês Anterior"
                        labelCurrentMonth="Mês Atual"
                        labelNextMonth="Próximo mês"
                        labelNextYear="Próximo Ano"
                        labelNextDecade="Próxima Decada"
                        labelToday:="Hoje"
                        labelSelected="Dia Selecionado"
                        labelNoDateSelected="Nenhum dia Selecionado"
                        labelCalendar="Datas do Abate"
                        labelNav="Navegador"
                        locale="pt-BR">
                    </b-calendar>
                  </b-col>
                </b-row>
            </b-card>
            <template #modal-footer="{ cancel }">
              <b-button  :disabled="producao.parametros.overlay"   variant="danger" @click="cancel()">
                Fechar
              </b-button>
            </template>
          </b-modal>
        </div>
      </div>
  </div>
</template>

<script>
import CardLine1ChartExample from '../dashboard/CardLine1ChartExample'
import CardLine2ChartExample from '../dashboard/CardLine2ChartExample'
import CardLine3ChartExample from '../dashboard/CardLine3ChartExample'
import CardBarChartExample from '../dashboard/CardBarChartExample'
import MainChartExample from '../dashboard/MainChartExample'
import SocialBoxChartExample from '../dashboard/SocialBoxChartExample'
import CalloutChartExample from '../dashboard/CalloutChartExample'
import { Callout } from '../../components/'
import DoughnutProducao from '../charts/DoughnutProducao'
import moment from 'moment'

export default {
  name: 'dashboard',
  components: {
    Callout,
    CardLine1ChartExample,
    CardLine2ChartExample,
    CardLine3ChartExample,
    CardBarChartExample,
    MainChartExample,
    SocialBoxChartExample,
    CalloutChartExample,
    DoughnutProducao
  },
  data: function () {
    return {
      enabledDates: [], // Aqui será armazenado o array de datas habilitadas
      listaResumo : {
        itens: [
        ]
      },
      doughnutProducaoPropria:{
        data: [],
        labels: [],
        backgrounds: []
      },
      doughnutProducaoServico:{
        data: [],
        labels: [],
        backgrounds: []
      },
      doughnutProducaoTotal:{
        data: [],
        labels: [],
        backgrounds: []
      },
      doughnutProducaoQualidade:{
        data: [],
        labels: [],
        backgrounds: []
      },
      producao: {
        dia: {
          busy: false
        },
        parametros: {
          data: '',
          overlay: false,
          lbData: ''
        }
      },
      selected: 'Month',
      tabelaOrdens: {
        items: [],
        fields: [
          {
            key: "ID",
            label: 'Id'
          },
          {
            key: "STATUS",
            label: 'Status'
          },
          {
            key: "GTA",
            label: 'GTA'
          },
          {
            key: "TIPO_SERVICO_TRADUZIDO",
            label: 'Tipo'
          },
          {
            key: "DT_LOTE",
            label: 'Data',
            class:'text-right',
            formatter: (value, key, item) => 
              moment(value).format("DD/MM/YYYY")
          },
          {
            key: "VACA_PECAS",
            label: 'Vaca',
            class:'text-right',
          },
          {
            key: "NOVILHA_PECAS",
            label: 'Novilha',
            class:'text-right',
          },
          {
            key: "TOURO_PECAS",
            label: 'Touro',
            class:'text-right',
          },
          {
            key: "ANIMAIS",
            label: 'Animais',
            class:'text-right',
          },
          {
            key: "QUANT",
            label: 'Peso KG',
            class:'text-right',
            formatter: (value, key, item) => 
              (value === null ? 0 : value).toLocaleString('pt-BR', {style: 'decimal'})
          },
          {
            key: "MEDIA",
            label: 'Média KG',
            class:'text-right',
             formatter: (value, key, item) => 
              (value === null ? 0 : value).toLocaleString('pt-BR', {style: 'decimal'})
          },
          {
            key: "NOME_FORNECEDOR",
            label: 'Fornecedor',
            formatter: (value, key, item) => 
              value.substr(0, 20)
          },
          {
            key: "actions" ,
            label: '',
            class:'text-right',
            thStyle: { width: '10% !important'} 
          }
          /*{
            key: "",
            label: ''
          },
          {
            key: 'VL_CREDITO', 
            class:'text-right', 
            label: 'Crédito (R$)', 
            sortable: true,
            thStyle: { width: '10% !important'},
            formatter: (value, key, item) => 
              (value === null ? 0 : value).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
          },
          {
            key: 'VL_DEBITO', 
            class:'text-right', 
            label: 'Débito (R$)', 
            sortable: true,
            thStyle: { width: '10% !important'},
            formatter: (value, key, item) => 
              (value === null ? 0 : value).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
          },*/
          
        ]
      },
      animais: {
        miudo: {
          quant: null,
          pecas: null,
          busy: false
        },
        banda: {
          quant: null,
          pecas: null,
          busy: false
        },
        boi: {
          id: null,
          quant: null,
          pecas: null,
          fields: [],
          items: [],
          totalRows: 0,
          busy: false
        },
        vaca: {
          id: null,
          quant: null,
          pecas: null,
          fields: [],
          items: [],
          busy: false
        },
        touro: {
          id: null,
          quant: null,
          pecas: null,
          fields: [],
          items: [],
          busy: false
        },
        novilha: {
          id: null,
          quant: null,
          pecas: null,
          fields: [],
          items: [],
          busy: false
        }
      }
    }
  },
  methods: {
    dateDisabled(ymd, date) {
      // Verifica se a data atual está no array de datas habilitadas
      const isEnabled = this.enabledDates.some(enabledDate => {
        return (
          enabledDate.getFullYear() === date.getFullYear() &&
          enabledDate.getMonth() === date.getMonth() &&
          enabledDate.getDate() === date.getDate()
        );
      });

      // Se a data não está habilitada, desabilite-a
      return !isEnabled;
    },
    variant (value) {
      let $variant
      if (value <= 25) {
        $variant = 'info'
      } else if (value > 25 && value <= 50) {
        $variant = 'success'
      } else if (value > 50 && value <= 75) {
        $variant = 'warning'
      } else if (value > 75 && value <= 100) {
        $variant = 'danger'
      }
      return $variant
    },
    variantStatus (value) {
      let $variant
      if (value === '4') {
        $variant = 'info'
      } else if (value === '5') {
        $variant = 'success'
      } else if (value === '6') {
        $variant = 'warning'
      } else if (value === '0') {
        $variant = 'danger'
      }
      return $variant
    },
    variantServico (value) {
      let $variant
      if (value === '0' || value === 0) {
        $variant = 'secondary'
      } else if (value === '1' || value === 1) {
        $variant = 'secondary'
      } else if (value === '2' || value === 2 ) {
        $variant = 'primary'
      } 
      return $variant
    },
    variantConta (value) {
      let $variant
      if (value < 0) {
        $variant = 'danger'
      } else {
        $variant = 'success'
      }
      return $variant
    },
    flag (value) {
      return 'flag-icon flag-icon-' + value
    },
    numberToReal (numero) {
      let n = numero.toFixed(2).split('.')
      n[0] = 'R$ ' + n[0].split(/(?=(?:...)*$)/).join('.')
      return n.join(',')
    },
    sortearCores(qtd) {
      let cores = [
        '#41B883',
        '#E46651',
        '#00D8FF',
        '#DD1B16',
        '#29363d',
        '##20a8d8',
        '#ffc107',
        '#6f42c1',
        '#6610f2',
        '#536c79'
        
      ]
      let retorno = []
      for (let i = 0; i < qtd ; i++) {
        retorno.push(cores[i])
      }
      return retorno
    },
    async onAbrirModalData() {
      await this.getDatasValidas()
      this.$refs['modal-data'].show()
    },
    onSelecionarNovaData() {
        this.producao.parametros.overlay = true
        return new Promise((reso, rej) => {
          this.atualizarGeral()
          this.producao.parametros.lbdata = new Date(this.producao.parametros.data).toISOString().substr(0, 10).split('-').reverse().join('/')
          reso(true)
          return true
      })
      .then(ok =>{
          this.$refs['modal-data'].hide()
          this.producao.parametros.overlay = false
      })
    },
    onImprimirProducao() {
      this.producao.dia.busy = true
      let dt1 = moment(this.producao.parametros.data).format('MM/DD/YYYY')
      let dt2 = dt1
      let uri = `/api/protected/relatorios/producao/periodo?lbusuario=${window.localStorage.getItem('nomeusuario')}&dt1=${dt1}&dt2=${dt2}`
      this.$http.get(uri, {responseType: 'arraybuffer'})
        .then(response => {
          this.$root.$bvToast.toast(`Relatório Gerado com sucesso!!!`, {
            title: 'Aviso',
            autoHideDelay: 2000,
            variant: 'success',
            appendToast: true
          })
          this.producao.dia.busy = false
          const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'relProducaoDia.pdf')
          link.download = 'relProducaoDia.pdf'
          // document.body.appendChild(link)
          //link.click()
          // document.body.removeChild(link)
          const janela = window.open(link)
          /*
          setTimeout(() =>
            { 
                janela.document.title = 'Relatório de Vendas'; 
            }, 1000);
            */
          janela.onload = function(){
            setTimeout(() => {
              janela.document.title = 'Producao do Dia'
            }, 1000);
          }
        })
        .catch(erro => {
          let msg = erro.response
          this.$root.$bvToast.toast(`Falha ao gerar o relatório!!! ` + msg, {
            title: 'Falha',
            autoHideDelay: 2000,
            variant: 'danger',
            appendToast: true
          })
          this.producao.dia.busy = false
        })
    },
    imprimirOrdem(id) {
      this.producao.dia.busy = true
      let uri = `/api/protected/relatorios/producao/abate/${id.item.ID}/${window.localStorage.getItem('nomeusuario')}`
      this.$http.get(uri, {responseType: 'arraybuffer'})
        .then(response => {
          this.$root.$bvToast.toast(`Relatório Gerado com sucesso!!!`, {
            title: 'Aviso',
            autoHideDelay: 2000,
            variant: 'success',
            appendToast: true
          })
          this.producao.dia.busy = false
          const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'relResumoAbate.pdf')
          link.download = 'relResumoAbate.pdf'
          // document.body.appendChild(link)
          //link.click()
          // document.body.removeChild(link)
          const janela = window.open(link)
          /*
          setTimeout(() =>
            { 
                janela.document.title = 'Relatório de Vendas'; 
            }, 1000);
            */
          janela.onload = function(){
            setTimeout(() => {
              janela.document.title = 'Abate'
            }, 1000);
          }
        })
        .catch(erro => {
          let msg = erro.response
          this.$root.$bvToast.toast(`Falha ao gerar o relatório!!! ` + msg, {
            title: 'Falha',
            autoHideDelay: 2000,
            variant: 'danger',
            appendToast: true
          })
          this.producao.dia.busy = false
        })

    },
    atualizarCars() {
      uri = this.$http.defaults.baseURL.concat('api/protected/parametro/getanimais')
      return this.$http.get(uri)
      .then((data) => {
        if (data) {
          this.animais.boi.id = data.data[0].BOI_ID
          this.animais.vaca.id = data.data[0].VACA_ID
          this.animais.touro.id = data.data[0].TOURO_ID
          this.animais.novilha.id = data.data[0].NOVILHA_ID
          return true
        }
      })
      .then((ok) => {
        let dt1 = moment(this.producao.parametros.data).format('MM/DD/YYYY')
        let dt2 = dt1
        uri = this.$http.defaults.baseURL.concat(`api/protected/producaodashboard/listarresumoanimal?dt1=${dt1}&dt2=${dt2}&tiposervico=1`)
        return this.$http.get(uri).then((data) => {
          if (data) {
            this.animais.boi.quant = 0.00
            this.animais.boi.pecas = 0
            this.animais.vaca.quant = 0.00
            this.animais.vaca.pecas = 0
            this.animais.touro.quant = 0.00
            this.animais.touro.pecas = 0
            this.animais.novilha.quant = 0.00
            this.animais.novilha.pecas = 0
            this.animais.banda.quant = 0.00
            this.animais.banda.pecas = 0

            for (let i = 0; i < data.data.length; i++) {
              if (this.animais.boi.id === data.data[i].PRODUTO_ID) {
                this.animais.boi.quant = data.data[i].QUANT
                this.animais.boi.pecas =  data.data[i].PECAS
              }
              else if (this.animais.vaca.id === data.data[i].PRODUTO_ID) {
                this.animais.vaca.quant = data.data[i].QUANT
                this.animais.vaca.pecas = data.data[i].PECAS
              }
              else if (this.animais.touro.id === data.data[i].PRODUTO_ID) {
                this.animais.touro.quant = data.data[i].QUANT
                this.animais.touro.pecas = data.data[i].PECAS
              }
              else if (this.animais.novilha.id === data.data[i].PRODUTO_ID) {
                this.animais.novilha.quant = data.data[i].QUANT
                this.animais.novilha.pecas = data.data[i].PECAS
              } 
              
              this.animais.banda.quant = data.data[i].QUANT
              this.animais.banda.pecas = data.data[i].PECAS
              
            }
            
            this.animais.boi.quant = this.animais.boi.quant.toLocaleString('pt-BR', {style: 'decimal',  minimumFractionDigits: 3})
            this.animais.vaca.quant = this.animais.vaca.quant.toLocaleString('pt-BR', {style: 'decimal',  minimumFractionDigits: 3})
            this.animais.touro.quant = this.animais.touro.quant.toLocaleString('pt-BR', {style: 'decimal',  minimumFractionDigits: 3})
            this.animais.novilha.quant = this.animais.novilha.quant.toLocaleString('pt-BR', {style: 'decimal',  minimumFractionDigits: 3})
            this.animais.banda.quant = this.animais.banda.quant.toLocaleString('pt-BR', {style: 'decimal',  minimumFractionDigits: 3})
          }
        })
      })
    },
    preencherTabelaOrdens () {
      let dt1 = moment(this.producao.parametros.data).format('MM/DD/YYYY')
      let dt2 = dt1
      let uri = this.$http.defaults.baseURL.concat(`api/protected/producaodashboard/listarordens?dt1=${dt1}&dt2=${dt2}&tiposervico=1`)
      this.$http.get(uri).then((data) => {
        if (data) {
          this.tabelaOrdens.items = data.data
          /*
          for (let i = 0; i < data.data.length; i++) {
            const element = data.data[i];
          }
          this.doughnutProducaoPropria.backgrounds = this.sortearCores(data.data.length)
          */
        }        
      })
    },
    async getDatasValidas (ymd, date) {
      let uri = this.$http.defaults.baseURL.concat(`api/protected/producao/getDatas`)

      this.$http.get(uri)
      .then((dados) => {
        
        if (!dados.data.length) {
            return 
        }
        const datesFromBackend = []
        this.enabledDates = []

        dados.data.forEach(d => {
            datesFromBackend.push(d.DT_LOTE)
        })
          
        // Converter as datas do formato ISO para objetos Date
        this.enabledDates = datesFromBackend.map(dateString => new Date(dateString));

        // Verifica se a data atual está definida
        if (!date) {
          return true // Se a data estiver indefinida, desabilite-a por precaução
        }

        // Verifica se a data atual está no array de datas habilitadas
        const isEnabled = this.enabledDates.some(enabledDate => {
          // Certifica-se de que enabledDate não seja undefined
          if (!enabledDate) {
            return false // Ignora datas indefinidas no array
          }

          return (
            enabledDate.getFullYear() === date.getFullYear() &&
            enabledDate.getMonth() === date.getMonth() &&
            enabledDate.getDate() === date.getDate()
          )
        })

        // Se a data não está habilitada, desabilite-a
        return !isEnabled;
        
      })
    },
    totalizarDoughnutProducaoQualidade() {
      let dt1 = moment(this.producao.parametros.data).format('MM/DD/YYYY')
      let dt2 = dt1
      this.doughnutProducaoQualidade.data = []
      this.doughnutProducaoQualidade.labels = []
      let uri = this.$http.defaults.baseURL.concat(`api/protected/producaodashboard/listarqualidades?dt1=${dt1}&dt2=${dt2}&tiposervico=1`)
      this.$http.get(uri).then((data) => {
        if (data) {
          for (let i = 0; i < data.data.length; i++) {
            const element = data.data[i];
            this.doughnutProducaoQualidade.data.push(data.data[i].PECAS_TOTAL)  
            this.doughnutProducaoQualidade.labels.push(data.data[i].SIGLA)  
          }
          this.doughnutProducaoQualidade.backgrounds = this.sortearCores(data.data.length)
        }        
      })
    },
    totalizarDoughnutProducaoPropria () {
      let dt1 = moment(this.producao.parametros.data).format('MM/DD/YYYY')
      let dt2 = dt1
      
      let uri = this.$http.defaults.baseURL.concat(`api/protected/producaodashboard/listarquantidades?dt1=${dt1}&dt2=${dt2}&tiposervico=1`)
      this.$http.get(uri).then((data) => {
        
        this.doughnutProducaoPropria.data = []
        this.doughnutProducaoPropria.labels = []
        this.doughnutProducaoPropria.backgrounds = null  
       
        if (data) {
          for (let i = 0; i < data.data.length; i++) {
            const element = data.data[i];
            this.doughnutProducaoPropria.data.push(data.data[i].PECAS_TOTAL)  
            this.doughnutProducaoPropria.labels.push(data.data[i].DESCRICAO)  
          }
          this.doughnutProducaoPropria.backgrounds = this.sortearCores(data.data.length)
        }      
      })
    },
    totalizarDoughnutProducaoServico () {
      let dt1 = moment(this.producao.parametros.data).format('MM/DD/YYYY')
      let dt2 = dt1
      let uri = this.$http.defaults.baseURL.concat(`api/protected/producaodashboard/listarquantidades?dt1=${dt1}&dt2=${dt2}&tiposervico=2`)
      this.$http.get(uri).then((data) => {
        if (data) {
          this.doughnutProducaoServico.data = []
          this.doughnutProducaoServico.labels = []
          for (let i = 0; i < data.data.length; i++) {
            const element = data.data[i];
            this.doughnutProducaoServico.data.push(data.data[i].PECAS_TOTAL)  
            this.doughnutProducaoServico.labels.push(data.data[i].DESCRICAO)  
          }
          this.doughnutProducaoServico.backgrounds = this.sortearCores(data.data.length)
        }        
      })
    },
    totalizarDoughnutProducaoTotal () {
      let dt1 = moment(this.producao.parametros.data).format('MM/DD/YYYY')
      let dt2 = dt1
      
      let uri = this.$http.defaults.baseURL.concat(`api/protected/producaodashboard/listarquantidades?dt1=${dt1}&dt2=${dt2}&tiposervico=0`)
      this.$http.get(uri).then((data) => {
        if (data) {
          this.doughnutProducaoTotal.data = []
          this.doughnutProducaoTotal.labels = []
          for (let i = 0; i < data.data.length; i++) {
            const element = data.data[i];
            this.doughnutProducaoTotal.data.push(data.data[i].PECAS_TOTAL)  
            this.doughnutProducaoTotal.labels.push(data.data[i].DESCRICAO)  
          }
          if (data.data.length > 0){
            this.doughnutProducaoTotal.backgrounds = this.sortearCores(data.data.length)
          }
          return(data)
        }        
      })
      .then (dados => {
        uri = this.$http.defaults.baseURL.concat('api/protected/parametro/getanimais')
        this.$http.get(uri)
        .then((data) => {
          if (data) {
            this.animais.boi.id = data.data[0].BOI_ID
            this.animais.vaca.id = data.data[0].VACA_ID
            this.animais.touro.id = data.data[0].TOURO_ID
            this.animais.novilha.id = data.data[0].NOVILHA_ID
            
            this.animais.boi.quant = 0.00
            this.animais.boi.pecas = 0
            this.animais.vaca.quant = 0.00
            this.animais.vaca.pecas = 0
            this.animais.touro.quant = 0.00
            this.animais.touro.pecas = 0
            this.animais.novilha.quant = 0.00
            this.animais.novilha.pecas = 0
            this.animais.banda.quant = 0.00
            this.animais.banda.pecas = 0

            for (let i = 0; i < dados.data.length; i++) {
              if (this.animais.boi.id === dados.data[i].PRODUTO_ID) {
                this.animais.boi.quant = dados.data[i].PESO_TOTAL
                this.animais.boi.pecas = 0 //dados.data[i].PECAS_TOTAL
              }
              else if (this.animais.vaca.id === dados.data[i].PRODUTO_ID) {
                this.animais.vaca.quant = dados.data[i].PESO_TOTAL
                this.animais.vaca.pecas = dados.data[i].PECAS_TOTAL
              }
              else if (this.animais.touro.id === dados.data[i].PRODUTO_ID) {
                this.animais.touro.quant = dados.data[i].PESO_TOTAL
                this.animais.touro.pecas = dados.data[i].PECAS_TOTAL
              }
              else if (this.animais.novilha.id === dados.data[i].PRODUTO_ID) {
                this.animais.novilha.quant = dados.data[i].PESO_TOTAL
                this.animais.novilha.pecas = dados.data[i].PECAS_TOTAL
              } 
              
            }
            this.animais.boi.quant = this.animais.boi.quant.toLocaleString('pt-BR', {style: 'decimal',  minimumFractionDigits: 3})
            this.animais.vaca.quant = this.animais.vaca.quant.toLocaleString('pt-BR', {style: 'decimal',  minimumFractionDigits: 3})
            this.animais.touro.quant = this.animais.touro.quant.toLocaleString('pt-BR', {style: 'decimal',  minimumFractionDigits: 3})
            this.animais.novilha.quant = this.animais.novilha.quant.toLocaleString('pt-BR', {style: 'decimal',  minimumFractionDigits: 3})

            return true
          }
        })
      })
    },
    
    myRowClickHandler (record, index) {
      this.$router.push(`/producaodashboard/listarResumoDoDia/${record.contaid.value}`)
    },
    atualizarlista() {
      let dt1 = moment(this.producao.parametros.data).format('MM/DD/YYYY')
      let dt2 = dt1
      let uri = `api/protected/producaodashboard/listarResumoDoDia?dt1=${dt1}&dt2=${dt2}`

      this.$http.get(uri)
      .then((data) => {
          this.listaResumo.itens = data.data
      })
    },
    atualizarGeral() {
      this.preencherTabelaOrdens()
      this.atualizarlista()
      this.totalizarDoughnutProducaoQualidade()
      this.totalizarDoughnutProducaoPropria()
      this.totalizarDoughnutProducaoServico()
      this.totalizarDoughnutProducaoTotal()
    },
    getCorCaixa (pecas) {
      return pecas == 0 ? 'caixa-vermelho' :  pecas > 0 ? 'caixa-verde' : 'caixa-laranja'
    }
  },
  computed:{
    
  },
  created () {
    this.producao.parametros.data = new Date().toISOString().substr(0, 10).split('-').join('-')
    this.atualizarGeral()
    this.producao.parametros.lbdata = new Date(this.producao.parametros.data).toISOString().substr(0, 10).split('-').reverse().join('/')
  },
  mounted () {
    this.producao.parametros.data = new Date().toISOString().substr(0, 10).split('-').join('-')
  },
  watch: {
  }
}
</script>
<style>
.text-azul {
  color: white !important;
  display: block !important;
  font-size: 20px !important;
}
.social-box.caixa-verde i {
    color: #fff;
    background: #4dbd74; }
  .social-box.caixa-laranja i {
    color: #fff;
    background: #f8cb00; }
  .social-box.caixa-vermelho i {
    color: #fff;
    background: #d34836; }
</style>


// WEBPACK FOOTER //
// src/views/producao/DashBoardProducao.vue